import React from "react";
import type { ICellRendererParams } from "@/ui/molecules/Grid";
import Box from "@/ui/atoms/Box";
import { capitalize } from "../utils";

type StatusCellRendererProps = Omit<ICellRendererParams, "value"> & {
    value: string;
};

type StatusColor = {
    text: string;
    background: string;
};

const statusColors: Record<string, StatusColor> = {
    completed: {
        text: "var(--proda-green)",
        background: "var(--proda-green-20)",
    },
    draft: {
        text: "var(--proda-teal)",
        background: "var(--proda-teal-10)",
    },
    with_proda: {
        text: "var(--proda-neon-blue)",
        background: "var(--proda-neon-blue-10)",
    },
};

export const StatusCellRenderer: React.FC<StatusCellRendererProps> = ({
    value,
}) => {
    if (!value) {
        return null;
    }
    const color = statusColors[value] || {
        text: "transparent",
        background: "transparent",
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                height: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "12px",
                    backgroundColor: color.background,
                    padding: "2px 8px",
                    height: "24px",
                }}
            >
                <Box
                    component="span"
                    sx={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: color.text,
                        marginRight: "6px",
                    }}
                />
                <span>{capitalize(value)}</span>
            </Box>
        </Box>
    );
};
